import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';

interface EnforcementSourceProps {
  /** Whose choice the row shows; absent on organization-scoped lists. */
  source: 'group' | 'organization' | undefined;
  groupName: string;
}

/**
 * KIR-4701: in a security-group scope, says whether a row's Allow/Block is the
 * group's own choice or inherited from the organization. Renders nothing in
 * the organization scope. The way back to the organization's choices is the
 * "Reset to organization default" beside the scope selector.
 */
export function EnforcementSource({
  source,
  groupName,
}: EnforcementSourceProps): ReactElement | null {
  if (!source) return null;
  if (source === 'organization') {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        Inherited from Organization
      </Badge>
    );
  }
  return (
    <Badge
      variant="outline"
      className="text-blue-700 border-blue-200 dark:text-blue-300 dark:border-blue-800"
    >
      Set for {groupName}
    </Badge>
  );
}
